<script lang="ts">
  import { onMount } from "svelte";
  import * as Sidebar from "$lib/components/ui/sidebar/index.js";
  import CvrTable from "$lib/components/cvr-table.svelte";
  import CvrNotificationSheet from "$lib/components/cvr-notification-sheet.svelte";
  import CvrExportExcelModal from "$lib/components/cvr-export-excel-modal.svelte";
  import TableToolbar from "$lib/components/table/table-toolbar.svelte";
  import TablePagination from "$lib/components/table/table-pagination.svelte";
  import { Button } from "$lib/components/ui/button";
  import { useCvrTable } from "$lib/hooks/use-cvr-table.svelte";

  const cvrTable = useCvrTable();

  onMount(() => {
    cvrTable.initialize();
  });
</script>

<Sidebar.Inset>
  <header class="flex h-16 items-center gap-2 border-b border-border px-4">
    <Sidebar.Trigger class="md:hidden" />
    <h2 class="text-lg font-semibold">CVR</h2>
  </header>
  <section class="p-6">
    <div class="space-y-4">
      <TableToolbar
        sortByOptions={cvrTable.sortByOptions}
        sortBy={cvrTable.sortBy}
        sortDirection={cvrTable.sortDirection}
        isLoading={cvrTable.isLoading}
        searchInput={cvrTable.searchInput}
        fromRow={cvrTable.fromRow}
        toRow={cvrTable.toRow}
        totalCount={cvrTable.totalCount}
        onSortByChange={cvrTable.changeSortBy}
        onSortDirectionToggle={cvrTable.toggleSortDirection}
        onSearchInput={cvrTable.scheduleSearch}
        minEmployees={cvrTable.minEmployees}
        maxEmployees={cvrTable.maxEmployees}
        createdFrom={cvrTable.createdFrom}
        createdTo={cvrTable.createdTo}
        companyForms={cvrTable.availableCompanyForms}
        selectedCompanyForms={cvrTable.selectedCompanyForms}
        reklamebeskyttetFilter={cvrTable.reklamebeskyttetFilter}
        hasWebsiteFilter={cvrTable.hasWebsiteFilter}
        activeFilterBadges={cvrTable.activeFilterBadges}
        onMinEmployeesChange={cvrTable.setMinEmployees}
        onMaxEmployeesChange={cvrTable.setMaxEmployees}
        onCreatedFromChange={cvrTable.setCreatedFrom}
        onCreatedToChange={cvrTable.setCreatedTo}
        onCompanyFormToggle={cvrTable.toggleCompanyForm}
        onReklamebeskyttetFilterChange={cvrTable.setReklamebeskyttetFilter}
        onHasWebsiteFilterChange={cvrTable.setHasWebsiteFilter}
        onFilterBadgeClear={cvrTable.clearFilterBadge}
      />

      <div class="space-y-2">
        {#if cvrTable.errorMessage}
          <p class="text-sm text-destructive">{cvrTable.errorMessage}</p>
        {/if}
        <CvrTable rows={cvrTable.rows} />
      </div>

      <TablePagination
        pageSizeOptions={cvrTable.pageSizeOptions}
        pageSize={cvrTable.pageSize}
        page={cvrTable.page}
        totalPages={cvrTable.totalPages}
        canGoPrevious={cvrTable.canGoPrevious}
        canGoNext={cvrTable.canGoNext}
        isLoading={cvrTable.isLoading}
        onPageSizeChange={cvrTable.changePageSize}
        onPrevious={cvrTable.goPrevious}
        onNext={cvrTable.goNext}
      />

      <div class="flex items-center gap-2">
        <CvrNotificationSheet />
        <Button type="button" onclick={cvrTable.openExportModal}>
          Export Excel
        </Button>
      </div>

      <CvrExportExcelModal
        open={cvrTable.isExportModalOpen}
        isDownloading={cvrTable.isExporting}
        errorMessage={cvrTable.exportErrorMessage}
        onCancel={cvrTable.closeExportModal}
        onDownload={cvrTable.downloadExcel}
      />
    </div>
  </section>
</Sidebar.Inset>
